// extracted by mini-css-extract-plugin
export const svg = "mandala-module--svg--2hc4P";
export const spin = "mandala-module--spin--AlUbk";
export const rotate = "mandala-module--rotate--26Fde";